import { Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_PHYSIC_POSITION} from '@wizeoo/akm-core-lib';
import {
  PopUpManager,
  WizBaseCollector,
  WizBasePopUp,
  WizDatasource,
  WizList,
  WizPopUp,
  WizVgroup,
  WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { WidgetConfigurationObj, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { EM_ACTION } from '@wizeoo/akm-compute-lib';
import { cloneDeep } from 'lodash-es';

import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { IFreedataWidget } from '../../../../manager/widgets/i-widget';
import { WIDGET_KIND } from '../../../../model/enums';
import { ViewData } from '../../../../model/view.data';
import { Model } from '../../../../model/model';
import { FreedataEditItemRenderer } from '../../freedatas/pops/freedata-edit-item.renderer';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { gridsterItemEvent } from '../../form/generic/form-widget.gridster.component';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { FreedataHeaderEditPop } from '../../freedatas/pops/freedata-header-edit.pop';
import { widgetHeaderVO } from '../../pivot/renderers/header/header-editext.pop';


@Component({
  selector: 'freeform-settings-pop',
  templateUrl: 'freeform-settings.pop.html',
})
export class FreeFormSettingsPop extends WizBasePopUp {
  // liste des champs et mesures disponibles
  @ViewChild('freeList', { read: WizList }) freeList: WizList;

  // zone globale des listes
  @ViewChild('vgDetailZone', { read: WizVgroup, static: false })
  vgDetailZone: WizVgroup;

  // dimensions demandées
  public static width: string = '1000px';
  public static height: string = 'calc(100% - 81px)';

  /** Renderer de la liste */
  public renderer: any = FreedataEditItemRenderer;

  public dataSource: WizDatasource<PivotField> = null; // DS des champs disponibles (au step)

  protected context: WidgetConfigurationObj; // la configuration
  protected updateCallback: Function; // la callback pour retour et traitement dans le pivotComponent
  
  public get widget(): IFreedataWidget {
    return this.datas;
  }

  public get model(): Model {
    return this.widget?.model;
  }
  
  protected doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)
  protected fieldPop: WizPopUp; // la popUp d'édition des champs

  constructor(public elementRef: ElementRef) {
    super();
  }

  show(): void {

    // this.isToolMode = !!this.fei.toolMode;
    this.context = cloneDeep(this.widget.context); 
    this.updateCallback = this.widget.backFromSettingsPop.bind(this.widget);

    // this.context = JSON.parse(JSON.stringify(this.datas[1]));
    // this.updateCallback = this.datas[2];
    // this.pivot = this.datas[3];

    const dataDS: PivotField[] = [];
    // ajout du fake pour mettre un texte libre
    let wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_HTML;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.content.$');
    const fakeLabel: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeLabel.order = -4;
    dataDS.push(fakeLabel);

    // ajout du fake pour mettre une image
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_IMAGE;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.image.$');
    const fakeImg: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeImg.order = -3;
    dataDS.push(fakeImg);

    // ajout du fake pour mettre un bouton connect
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_ACTION;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.action.$');
    const fakeAction: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeImg.order = -2;
    dataDS.push(fakeAction);

    // ajout du fake pour mettre une zone de drop
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_DROP;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.drop.$');
    const fakeDrop: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeImg.order = -1;
    dataDS.push(fakeDrop);

    this.dataSource = new WizDatasource<PivotField>(dataDS)
    .setItemCodeField('code')
    .setSelectionMode('none')
    .setSortFields([{ property: 'order', way: 'asc', numeric: true },{ property: 'labelOrDefaultLabel', way: 'asc', numeric: false }]) //  
    .build();

    this.widgets = [];
    if (this.context.ff) {
      this.context.ff.forEach((obj: WidgetConfigurationItemObj) => {
        if(ViewData.isFreeField(obj.fdvf)) {
          const result: GridsterWidgetItem = new GridsterWidgetItem(obj, new PivotField(this.widget, obj, null, null));
          this.widgets.push(result);
        }
      });      
    }   
  }


  /** icone de suppression globale */
  public onDeleteClick(): void {
    this.widgets = [];
  }


  /** validation du contenu */
  public doValid(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  widgets: GridsterWidgetItem[] = [];

  /** modification du context pour retour sur la base des params */
  public updateContext(): void {

    this.context.r = [];
    this.context.f = [];

    this.context.ff = this.widgets.map((obj) => obj.source);
  }

  public onHide() {
    if (this.doSaveFlag) {
      if (!!this.updateCallback) {
        this.updateContext();
        this.updateCallback(this.context);
      }
    }
  }

  /* ##############################################################################
                    filtre et rendu de la DS principale
     ############################################################################## */

  onWidgetsChanged(event: gridsterItemEvent) {
    // console.log('onWidgetsChanged',event, this.widgets);
    switch(event.action) {
      case EM_ACTION.CREATE:
        this.widgets = [event.item, ...this.widgets];
        break;
      case EM_ACTION.UPDATE:
        // console.log('onWidgetsChanged rien a faire');
        event.item.updateCoords(); // mise à jour des coords
        break;
      case EM_ACTION.DELETE:
        this.widgets.splice(this.widgets.indexOf(event.item), 1);
        break;     
    }
  }



  /* ##############################################################################
                  modification du contenu de l'une des zones
    ############################################################################## */


  /**
   * demande d'affichage de la popUp de configuration des champs
   * @param e alkEvent, data = [pivotField, wizBaseCollector]
   */
  protected showConfPop(e: AlkEvent): void {
    if (PopUpManager.exist(this.fieldPop)) {
      // suppression de l'instance existante
      this.fieldPop.hide();
    }

    // // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.fieldPop = new WizPopUp( FreedataHeaderEditPop, true, false, WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      FreedataHeaderEditPop.baseWidth + 'px',
      FreedataHeaderEditPop.baseHeight + 'px');

    // construction des données
    const datas: widgetHeaderVO = {
      popReference: this.fieldPop,
      fei: null,
      context: this.context,
      updateCallback: this.backFromFieldPop.bind(this),
      pivotField: e.data[0],
      baseCollector: e.data[1],
      popUpMode: WIDGET_KIND.GRID,
      widget: this.widget
    };

    // // alimentation des datas
    this.fieldPop.datas = datas;

    this.fieldPop.show();
  }

  /**
   * retour d'édition de champ
   * @param wbc la collection d'origine, transmise par l'event de showConfPop
   * @param pf PivotField
   */
  protected backFromFieldPop(wbc: WizBaseCollector, pf: PivotField): void {
    wbc.wizDataProvider.refresh();
  }

}
